/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// material
import Space from 'material/space/space';
import { SortableList} from '@insticator/insticator-ui';
import { SectionGroupV2 } from 'material/expandablesection/v2'
import { ReactComponent as LockIcon } from 'assets/icons/lock.svg'
// styles
import injectSheet from 'react-jss'
import styles from './products_styles'


/* ========== ~~~~~~~~~~ PRODUCT MANAGER: SITE SETUP : FEATURES ~~~~~~~~~~ ========== */
const Products = injectSheet(styles)((props) => {

  const { accountProducts, pendingAccountProducts } = useSelector((state) => state.account);

  const { showCommenting, showTrendingNow, onChange, onFieldsChange } = props

  const dispatch = useDispatch()
  
  // TODO: Sortable products. Currently only we have commenting
  const productOptions = useMemo(() => {
    const PRODUCTS_OPTIONS = [
      {value: 'COMMENTING_V2', text: <Space justifyContent={'space-between'}>Commenting</Space>},
      {value: 'TRENDING_NOW_V2', text:  <Space justifyContent={'space-between'}>Trending Now</Space>},
      {value: 'ARTICLE_SENTIMENT_V2', text:  <Space justifyContent={'space-between'}>Article Sentiment </Space>},
    ];
    return PRODUCTS_OPTIONS.filter(product => accountProducts.includes(product.value))
  }, [accountProducts])

  const [indices, setIndices] = useState(productOptions.map(item => item.value));
  const [selected, setSelected] = useState(showCommenting ? ['COMMENTING_V2'] : [])

  useEffect(() => {
    setIndices(productOptions.map(item => item.value))
  }, [accountProducts, productOptions])
  

  useEffect(() => {
    if(showCommenting && !selected.includes('COMMENTING_V2')) setSelected([...selected, 'COMMENTING_V2'])
    if(!showCommenting && selected.includes('COMMENTING_V2')) setSelected([...selected].filter(product => product !== 'COMMENTING_V2'))
  }, [selected, showCommenting])

  useEffect(() => {
    if(showTrendingNow && !selected.includes('TRENDING_NOW_V2')) setSelected([...selected, 'TRENDING_NOW_V2'])
    if(!showTrendingNow && selected.includes('TRENDING_NOW_V2')) setSelected([...selected].filter(product => product !== 'TRENDING_NOW_V2'))
  }, [selected, showTrendingNow])


  const handleToggle = (orders, value) => {
    let productsOrder = {}
    if (selected.includes(value)) {
        setSelected(selected.filter(i => i !== value))
        if(value === 'COMMENTING_V2') productsOrder = {...productsOrder, showCommenting: false}
        if(value === 'TRENDING_NOW_V2') productsOrder = {...productsOrder, showTrendingNow:  false}
    } else {
        setSelected([...selected, value])
        if(value === 'COMMENTING_V2') productsOrder = {...productsOrder, showCommenting: true}
        if(value === 'TRENDING_NOW_V2') productsOrder = {...productsOrder, showTrendingNow:  true}
    }

    orders.forEach((order, index) => {
      const newOrder = index + 1
      if(order === 'COMMENTING_V2') productsOrder = {...productsOrder, commentingOrder: newOrder}
      if(order === 'TRENDING_NOW_V2') productsOrder = {...productsOrder, trendingNowOrder: newOrder}
    })
    onFieldsChange(productsOrder)
  }

  const handleOrderChange = (orders) => {
    setIndices(orders)
    let productsOrder = {}
    orders.forEach((order, index) => {
      const newOrder = index + 1
      if(order === 'COMMENTING_V2') productsOrder = {...productsOrder, commentingOrder: newOrder}
      if(order === 'TRENDING_NOW_V2') productsOrder = {...productsOrder, trendingNowOrder: newOrder}
    })
    onFieldsChange(productsOrder)
  }


  return (
    <SectionGroupV2 
      klass={`products ${props.classes.products}`} 
      title={'Products'} 
      description={'Enable and sort products you’d like to group together on your site.'}
      direction={'column'}
    >
      <SortableList 
        items={productOptions} 
        error={{"enabled":false,"message":"This is an error!"}} 
        order={indices || []} 
        selected={selected || []}
        type={'switch'}
        handleChange={(order, value) => handleToggle(order, value)}
        handleOrderChange={(order, value) => handleOrderChange(order, value)}
      />
      {!accountProducts.includes('COMMENTING_V2') && !pendingAccountProducts.includes('COMMENTING_V2') (
        <Space klass={`productitem`} justifyContent={'space-between'}>
          Commenting
        </Space>
      )}
      {!accountProducts.includes('TRENDING_NOW_V2') && !pendingAccountProducts.includes('TRENDING_NOW_V2')  && (
        <Space klass={`productitem`} justifyContent={'space-between'}>
          Trending Now
        </Space>
      )}
      <Space klass={`productitem`} justifyContent={'space-between'}>
        Article Sentiment
        <LockIcon width={16} height={16}  />
      </Space>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Products;